import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bike-gear-management',
  templateUrl: './bike-gear-management.component.html',
  styleUrls: ['./bike-gear-management.component.scss'],
})
export class BikeGearManagementComponent implements OnInit {
  public navigationItems: any = [
    {
      title: 'Component Management',
      backgroundImage:
        '../../../../../../assets/backgrounds/component-management.jpg',
    },
    {
      title: 'Gear Advice Management',
      backgroundImage: '../../../../../../assets/backgrounds/gear-advice.jpg',
      path: 'administration/bike-gear-advices',
    },
  ];

  constructor() {}

  ngOnInit() {}
}
